module.exports = __webpack_public_path__ + "img/10.3923e0cc.svg";